export default __webpack_public_path__ + "static/media/email_icon-white.9396a190.svg";